const isVideoExhausted = (content) => {
  return content?.isVideoRestricted && (content?.videoCountAvailable === 0 || content?.videoDurationAvailable == 0);
};

export default isVideoExhausted;
